module.exports = __webpack_public_path__ + "img/logo_fullfreela_white.2976a89d.svg";